<template>
	<div>
		<div class="w-full">
			<GridLayout
				:sidebarState="false"
				:showSearchBar="false"
				:reactiveSidebar="false"
			>
				<template #right-header>
					<router-link
						v-if="step === 'menu'"
						:to="{ name: 'Home' }"
						class="btn btn-rounded"
					>
						<i class="fas fa-chevron-left"></i>
					</router-link>
					<button
						v-else
						class="btn btn-rounded"
						@click="Previous"
					>
						<i class="fas fa-chevron-left"></i>
					</button>
					<Title :value="currentTitle" />
					<button
						class="btn-preference"
						:class="{ active: isPreferenceActive }"
						@click="isPreferenceActive = !isPreferenceActive"
					>
						<i
							class="fa-star"
							:class="isPreferenceActive ? 'fas' : 'far'"
						>
						</i>
					</button>
				</template>
				<template #right-content>
					<transition
						name="fade"
						mode="out-in"
					>
						<div
							v-if="step === 'menu'"
							key="menu"
							class="d-flex h-full justify-content-center align-items-center gap-6"
						>
							<button
								class="btn btn-menu-fixed-size"
								@click="WalkStep('stamps')"
							>
								<i class="fas fa-stamp"></i>
								CARIMBO
							</button>
							<button
								class="btn btn-menu-fixed-size"
								@click="WalkStep('others')"
							>
								<i class="fas fa-ellipsis-h"></i>
								OUTROS
							</button>
						</div>

						<div
							v-if="step === 'stamps'"
							key="stamps"
							class="main-content w-full"
						>
							<Stamps />
						</div>

						<div
							v-if="step === 'others'"
							key="others"
							class="main-content w-full"
						>
							<Index
								ref="others"
								:props_tab="'data'"
								@footer-action-change="HandleFooterActionChange"
							/>
						</div>
					</transition>
				</template>
				<template #right-footer>
					<div
						v-if="step === 'others'"
						class="w-full h-full flex justify-end items-center"
					>
						<button
							v-if="othersFooterAction.visible"
							class="btn btn-success px-5"
							type="button"
							:disabled="othersFooterAction.disabled"
							@click="TriggerOthersFooterAction"
						>
							{{ othersFooterAction.label }}
						</button>
					</div>
				</template>
			</GridLayout>
		</div>
	</div>
</template>

<script>
	import Index from './Others.vue'
	import Stamps from './sections/stamps/Stamps.vue'
	import Toolbar from '../shared/layout/ToolBar.vue'

	export default {
		name: 'Profile',
		components: {
			Index,
			Stamps,
			Toolbar,
		},
		data() {
			return {
				step: 'menu',
				othersFooterAction: {
					visible: false,
					label: '',
					disabled: false,
				},
				isPreferenceActive: false,
			}
		},
		computed: {
			currentTitle() {
				const titles = {
					menu: 'PERFIL',
					stamps: 'CARIMBO',
					others: 'OUTROS',
				}

				return titles[this.step] || titles.menu
			},
		},
		methods: {
			WalkStep(step) {
				this.step = step

				if (step !== 'others') {
					this.othersFooterAction = {
						visible: false,
						label: '',
						disabled: false,
					}
				}
			},
			Previous() {
				this.step = 'menu'
				this.othersFooterAction = {
					visible: false,
					label: '',
					disabled: false,
				}
			},
			HandleFooterActionChange(action) {
				this.othersFooterAction = action || {
					visible: false,
					label: '',
					disabled: false,
				}
			},
			TriggerOthersFooterAction() {
				if (
					this.$refs.others &&
					this.$refs.others.TriggerFooterAction
				) {
					this.$refs.others.TriggerFooterAction()
				}
			},
		},
	}
</script>

<style lang="scss" scoped>
	:deep #right-content {
		justify-content: start !important;
		padding-top: 0 !important;
	}

	.btn-menu-fixed-size {
		display: flex;
		flex-direction: column;
		justify-content: center;
		width: 12.5rem;
		height: 12.5rem;
		background-color: var(--backgroundColor);
		border: none;
		border-radius: 0.5rem;
		font-weight: normal;
		letter-spacing: 0.1em;
		font-size: 0.75rem;
		font-family: 'Avenir Next Light';

		i {
			font-size: 2.25rem;
			margin-bottom: 1rem;
		}
	}

	.btn-preference {
		width: 1.875rem;
		height: 1.875rem;
		font-size: 1.25rem;
		background: none;
		border: none;
		color: var(--elementsBorderColor);
		padding: 0;

		&:hover {
			color: var(--newPrimaryActiveBackgroundColor);
		}

		&.active {
			color: var(--newPrimaryActiveBackgroundColor);
		}
	}

	a:hover,
	.link:hover {
		color: var(--newPrimaryHoverColor) !important;
	}

	.profile-content {
		min-height: 1px;
	}
</style>
